export enum FeatureToggles {
  HealthcareProviders = 'healthcare providers',
}
